module.exports = __webpack_public_path__ + "static/ptp-pres2-41986db44d9f0901ae4be0f3b58eeb4c.png";